import mixpanel from "mixpanel-browser";

mixpanel.init("cd3ad2f5ac88f8b0a9c7a2372ad632bb", {
  track_pageview: false,
  persistence: "localStorage",
  api_host: "https://api-eu.mixpanel.com",
});

export default mixpanel;
